<template>
  <v-card color="primary" dark width="100%">
    <v-card-text>
      {{ mensaje }}
      <v-progress-linear indeterminate color="white" class="mb-0" />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    mensaje: {
      type: String,
      default: 'loading'
    }
  }
}
</script>
